import React, { Component } from "react";

import { YearGraph } from "common";

class DemoGoogleAnalyticsSessionsByMonth extends Component {
    static defaultProps = {
        displayYOY: false
    };

    state = { isFetching: false };
    mounted = true;

    render() {
        // Fixtures
        const year = "2018"
        const isFetching = false;
        const displayYOY = false;
        const sessions = [
            {
                "month": 1,
                "label": "Jan",
                "currentData": 2022,
                "previousData": 500
            },
            {
                "month": 2,
                "label": "Feb",
                "currentData": 2174,
                "previousData": 500
            },
            {
                "month": 3,
                "label": "Mar",
                "currentData": 2622,
                "previousData": 500
            },
            {
                "month": 4,
                "label": "Apr",
                "currentData": 2474,
                "previousData": 500
            },
            {
                "month": 5,
                "label": "May",
                "currentData": 3490,
                "previousData": 500
            },
            {
                "month": 6,
                "label": "Jun",
                "currentData": 4348,
                "previousData": 500
            },
            {
                "month": 7,
                "label": "Jul",
                "currentData": 2894,
                "previousData": 500
            },
            {
                "month": 8,
                "label": "Aug",
                "currentData": 2690,
                "previousData": 500
            },
            {
                "month": 9,
                "label": "Sep",
                "currentData": 2345,
                "previousData": 500
            },
            {
                "month": 10,
                "label": "Oct",
                "currentData": 2600,
                "previousData": 500
            },
            {
                "month": 11,
                "label": "Nov",
                "currentData": 3000,
                "previousData": 500
            },
            {
                "month": 12,
                "label": "Dec",
                "currentData": 2800,
                "previousData": 500
            }
        ]
        return (
            <YearGraph
                className={"yearly-graph"}
                title="Sessions By Month"
                yLabel="Sessions"
                isLoading={isFetching}
                displayYOY={displayYOY}
                data={sessions}
                year={year}
            />
        );
    }
}


export default DemoGoogleAnalyticsSessionsByMonth;
